module.exports = __webpack_public_path__ + "img/20.5c5578fa.png";